export var DEFAULT_WIDTH = {
  minWidth: 130,
  eyeWidth: 48,
  checkboxWidth: 48
};
export var TABLE_CELL_HORIZONTAL_PADDING = 16;
export var TABLE_CELL_ICON_HORIZONTAL_PADDING = 8;
export var TABLE_HEAD_FIXED_CLASS = 'EmbersTableHead-fixed';
export function getPadding(v) {
  return v.icon ? TABLE_CELL_ICON_HORIZONTAL_PADDING : TABLE_CELL_HORIZONTAL_PADDING;
}
export function getCellWidth(v) {
  return v.width || v.minWidth || DEFAULT_WIDTH.minWidth + getPadding(v);
}
export function getMinCellWidth(defaultHeadCells, v) {
  if (v.width === 0) {
    return v.minWidth ? v.minWidth + getPadding(v) : DEFAULT_WIDTH.minWidth + getPadding(v);
  }
  var initialCell = defaultHeadCells.find(function (cell) {
    return cell.id === v.id;
  });
  return initialCell !== null && initialCell !== void 0 && initialCell.width && initialCell.width < DEFAULT_WIDTH.minWidth + getPadding(v) ? initialCell.width || 0 : v.minWidth ? v.minWidth + getPadding(v) : DEFAULT_WIDTH.minWidth + getPadding(v);
}

/**
 * Initialize the cell width as the width is possible not defined or has a pointed auto expand column
 * If no width defined, it should be the minWidth or default minWidth
 */
export function initializeCellWidth(v) {
  return v.width === undefined ? v.freezeWidth ? v.minWidth || DEFAULT_WIDTH.minWidth : DEFAULT_WIDTH.minWidth : v.width || 0;
}